export var TokenType;
(function (TokenType) {
    TokenType["BADGE"] = "Badge";
    TokenType["CAPTION"] = "Caption";
    TokenType["CODE_BLOCK"] = "CodeBlock";
    TokenType["CODE_IN_CODE"] = "CodeInCode";
    TokenType["CODE_INLINE"] = "CodeInline";
    TokenType["COLOR"] = "Color";
    TokenType["DOCUMENT"] = "Document";
    TokenType["HEADING"] = "Heading";
    TokenType["HEADING_FIRST"] = "HeadingFirst";
    TokenType["HEADING_SECOND"] = "HeadingSecond";
    TokenType["HEADING_THIRD"] = "HeadingThird";
    TokenType["HEADING_FOURTH"] = "HeadingFourth";
    TokenType["HEADING_FIFTH"] = "HeadingFifth";
    TokenType["IMAGE"] = "Image";
    TokenType["LINK"] = "Link";
    TokenType["LIST"] = "List";
    TokenType["LIST_ITEM"] = "ListItem";
    TokenType["PARAGRAPH"] = "Paragraph";
    TokenType["PARAGRAPH_START"] = "ParagraphStart";
    TokenType["PARAGRAPH_END"] = "ParagraphEnd";
    TokenType["QUOTE"] = "Quote";
    TokenType["STRONG"] = "Strong";
    TokenType["TABLE"] = "Table";
    TokenType["TABLE_HEAD_ROW"] = "TableHeadRow";
    TokenType["TABLE_BODY_ROW"] = "TableBodyRow";
    TokenType["TABLE_CELL"] = "TableCell";
    TokenType["TEXT"] = "Text";
    TokenType["UNDER_LINE"] = "UnderLine";
    TokenType["UNKNOWN_TEXT"] = "UnknownText";
    TokenType["UNMARKABLE"] = "Unmarkable";
    TokenType["FORMULA_BLOCK"] = "FormulaBlock";
    TokenType["FORMULA_INLINE"] = "FormulaInline";
})(TokenType || (TokenType = {}));
